import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-rate@2.4.3@rc-rate/es/index.js
// module id = 684
// module chunks = 0 1